export default {
  focus(name, timeout) {
    setTimeout(() => {
      var elements = document.getElementsByName(name);
    
      elements.forEach(element => {
        if(element.form){
          element.focus();

          return;
        }
      })
    }, timeout ?? 0);
  }
};
